export default __webpack_public_path__ + "static/media/frango.0e314b03.jpg";